'use strict';

/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/call-bind-apply-helpers/functionApply.js
// module id = 1046
// module chunks = 0